import React from 'react';
import { Link } from 'react-router-dom';

const KJSMunicipalityRow = (props) => {
  const { kjsMunicipality, handleDelete } = props || {},
    { kjs } = kjsMunicipality || {};

  const onDeleteClick = (kjsMunicipality) => {
    handleDelete(kjsMunicipality);
  };

  return (
    <tr>
      <td className="text-left">{kjs?.name}</td>
      <td className="text-center">
        <Link
          id="deleteDocument"
          onClick={() => onDeleteClick(kjsMunicipality)}
          to="#"
        >
          <i className="fas fa-trash-alt fa-2x iconColor deleteIcon" />
        </Link>
      </td>
    </tr>
  );
};

export default KJSMunicipalityRow;
